    export const ja = {
      // Meta Tags
      meta: {
        title: '青島検査技術サービス ISO 17025 検査研究所',
        description: 'ILAC認定国際公認検査機関。ファッションジュエリー、乳幼児用品および一般商品の欧米有害物質法令検査分析専門。ISO/IEC 17025認証保有。有害物質検査、子供用品安全性検査、適合性評価サービス提供。',
        keywords: '検査機関, 有害物質検査, 子供用品安全性, ISO 17025, ILAC認定, ファッションジュエリー分析',
        ogTitle: 'ISO 17025 検査研究所 - 国際公認検査機関',
        ogDescription: 'ILAC認定国際公認検査機関。有害物質検査分析専門'
      },

      // Navigation
      nav: {
        home: 'ホーム',
        about: '会社案内',
        services: 'サービス',
        certifications: '認証資格',
        equipment: '設備紹介',
        virtualTour: 'バーチャルツアー',
        resources: '資料センター',
        contact: 'お問い合わせ',
        business: '主要業務',
        testingAnalysis: '試験/分析',
        productTesting: '製品試験評価',
        certificationMark: '認証業務/認証マーク',
        customerSupport: '顧客・技術支援',
        industrySolutions: '業界別ソリューション',
        certificationSupport: '認証制度サポート(分野別)',
        technicalCenter: '技術センター(付属)',
        jewelry: 'ジュエリー',
        childrenBaby: '子供・乳幼児用品',
        educationCenter: '教育センター',
        regulationResearch: '法規研究/標準開発',
        equipmentCertifications: '設備/資格',
        announcements: 'お知らせ',
        location: 'アクセス',
        ceoMessage: 'CEO挨拶',
        managementPolicy: '経営方針',
        companyInfo: '会社紹介',
        companyHistory: '会社沿革',
        organization: '組織図'
      },

      // Hero Section
      hero: {
        badge: 'ISO/IEC 17025 認証',

        // Slide titles
        slide1Title: '先端化学分析',
        slide2Title: '総合製品安全試験',
        slide3Title: '研究開発支援',
        slide4Title: '環境認証及びカーボンフットプリント',

        // Slide 1
        slide1MainTitle: 'ISO/IEC 17025 認証第三者公認試験機関',
        slide1Point1: '正確な分析データに基づき',
        slide1Point1Text: '正確な分析データに基づき',
        slide1Point2: '信頼性の高い試験成績書と証明書を提供します。',
        slide1Point2Text: '信頼性の高い試験成績書と証明書を提供します。',

        // Slide 2
        slide2MainTitle: '最高水準の技術標準と専門エンジニア',
        slide2Point1: '安全/衛生環境を考慮した厳格な製品認証規格',
        slide2Point1Text: '安全/衛生環境を考慮した厳格な製品認証規格',
        slide2Point2: '長年の経験を通じて蓄積された専門評価サービス',
        slide2Point2Text: '長年の経験を通じて蓄積された専門評価サービス',
        slide2Point3: '顧客と市場が信頼する試験認証専門機関',
        slide2Point3Text: '顧客と市場が信頼する試験認証専門機関',

        // Slide 3
        slide3MainTitle: '研究開発・技術サービス',
        slide3Point1: '不良原因の技術分析とソリューション',
        slide3Point1Text: '不良原因の技術分析とソリューション',
        slide3Point2: '材料選定から完成品までの全プロセス支援',
        slide3Point2Text: '材料選定から完成品までの全プロセス支援',
        slide3Point3: 'お客様と市場に信頼される検査・認証の専門機関',
        slide3Point3Text: 'お客様と市場に信頼される検査・認証の専門機関',

        // Slide 4
        slide4MainTitle: '環境認証と持続可能性',
        slide4Point1: 'カーボンフットプリント評価',
        slide4Point1Text: '総合的なカーボンフットプリント評価を提供します',
        slide4Point2: '環境影響評価',
        slide4Point2Text: '詳細な環境影響評価サービスを提供します',
        slide4Point3: '持続可能な開発目標: ',
        slide4Point3Text: '持続可能な開発目標: 企業の持続可能性目標達成と国際環境基準遵守を支援します。',

        // Products
        product1: 'ジュエリー/ファッションアクセサリー',
        product2: 'おもちゃ/ベビー用品',
        product3: 'ベビー服',
        product4: 'イヤリング',
        product5: 'ベビー枕',
        product6: 'レゴスパイク',
        product7: 'レディースブラウス',
        product8: 'ゴールドブレスレット',
        product9: '自転車ヘルメット',
        product10: 'ギアホイール',
        product11: '文房具',
        product12: '繊維/皮革製品',
        product13: '家具/室内装飾',
        product14: '食器/食品容器',
        product15: '包装/輸送',
        product16: '検査/現場テスト',

        // Equipment
        equipment1Name: 'GC-MS',
        equipment1Desc: 'Agilent Technologiesのガスクロマトグラフィー質量分析装置です。有機化合物分析及び微量成分検出に使用されます。',
        equipment1App1: '有機化合物分析',
        equipment1App2: '揮発性物質検出',
        equipment1App3: '環境汚染物質分析',
        equipment2Name: '設備 2',
        equipment2Desc: '2番目の設備の説明です。写真をアップロードしていただくと、実際の設備情報に更新されます。',
        equipment2App1: '応用分野 1',
        equipment2App2: '応用分野 2',
        equipment2App3: '応用分野 3',
        equipment3Name: '設備 3',
        equipment3Desc: 'Rayleigh UV-1801紫外/可視分光光度計です。物質の吸光度測定及び濃度分析に使用されます。',
        equipment3App1: '吸光度測定',
        equipment3App2: '濃度分析',
        equipment3App3: '物質定性/定量分析',
        equipment4Name: '設備 4',
        equipment4Desc: '4番目の設備の説明です。写真をアップロードしていただくと、実際の設備情報に更新されます。',
        equipment5Name: '設備 5',
        equipment5Desc: '5番目の設備の説明です。写真をアップロードしていただくと、実際の設備情報に更新されます。',
        equipment6Name: '設備 6',
        equipment6Desc: '6番目の設備の説明です。写真をアップロードしていただくと、実際の設備情報に更新されます。',
        equipment7Name: '設備 7',
        equipment7Desc: 'ETHOS EASYマイクロ波分解システムです。サンプルの前処理及び分解作業に使用される高度な設備です。',
        equipment7App1: 'サンプル前処理',
        equipment7App2: 'マイクロ波分解',
        equipment7App3: '金属分析前処理',
        equipment8Name: '設備 8',
        equipment8Desc: '高温マッフル炉(Muffle Furnace)です。サンプルの灰化、熱処理及び高温実験に使用される必須設備です。',
        equipment8App1: 'サンプル灰化',
        equipment8App2: '高温熱処理',
        equipment8App3: '灰分含有量測定',
        equipment9Name: '設備 9',
        equipment9Desc: '9番目の設備の説明です。写真をアップロードしていただくと、実際の設備情報に更新されます。',
        equipment10Name: '設備 10',
        equipment10Desc: '10番目の設備の説明です。写真をアップロードしていただくと、実際の設備情報に更新されます。',
        equipment11Name: '設備 11',
        equipment11Desc: '11番目の設備の説明です。写真をアップロードしていただくと、実際の設備情報に更新されます。',
        equipment12Name: '設備 12',
        equipment12Desc: '12番目の設備の説明です。写真をアップロードしていただくと、実際の設備情報に更新されます。',
        equipment13Name: '設備 13',
        equipment13Desc: '13番目の設備の説明です。写真をアップロードしていただくと、実際の設備情報に更新されます。',
        equipment14Name: '設備 14',
        equipment14Desc: '14番目の設備の説明です。写真をアップロードしていただくと、実際の設備情報に更新されます。',
        equipment15Name: '設備 15',
        equipment15Desc: 'COX EM-30AX先進分析システムです。精密分析及び測定に使用される高度な設備です。',
        equipment15App1: '精密分析',
        equipment15App2: '成分測定',
        equipment15App3: '品質管理',
        equipment16Name: '設備 16',
        equipment16Desc: '16番目の設備の説明です。写真をアップロードしていただくと、実際の設備情報に更新されます。',
        equipment17Name: '設備 17',
        equipment17Desc: '17番目の設備の説明です。写真をアップロードしていただくと、実際の設備情報に更新されます。',
        equipment18Name: '設備 18',
        equipment18Desc: 'Vision検出システムです。製品の外観検査及び品質管理に使用される精密検出設備です。',
        equipment18App1: '外観検査',
        equipment18App2: '品質管理',
        equipment18App3: '欠陥検出',
        equipment19Name: '設備 19',
        equipment19Desc: 'X線蛍光分析装置(XRF)です。非破壊方式で物質の元素組成を分析する精密設備です。',
        equipment19App1: '元素分析',
        equipment19App2: '非破壊検出',
        equipment19App3: '金属成分分析',
        equipment20Name: '設備 20',
        equipment20Desc: '20番目の設備の説明です。写真をアップロードしていただくと、実際の設備情報に更新されます。',
        equipment21Name: '設備 21',
        equipment21Desc: '21番目の設備の説明です。写真をアップロードしていただくと、実際の設備情報に更新されます。',

        // Cards
        card1Title: 'ISO 17025 認証',
        card1Desc: '国際公認試験所品質管理システム',
        card2Title: 'グローバルネットワーク',
        card2Desc: 'ILAC MRA 相互認定協定加盟',
        card3Title: '先端設備',
        card3Desc: '最新分析装置と専門人材',
        card4Title: '専門チーム',
        card4Desc: '豊富な経験の専門家グループ',

        // Buttons
        btnServices: 'サービスを見る',
        btnContact: 'お問い合わせ'
      },

      // About Section
      about: {
        badge: '会社紹介',
        title: 'CTL 紹介',
        subtitle: '信頼と専門性でお客様の成功を支援する国際公認試験所',
        mission: '私たちのミッション',
        missionDesc: '最高水準の試験分析サービスを通じてお客様の製品が全世界市場で安全に流通できるよう支援し、消費者の健康と安全を保護することに貢献します。',
        vision: '私たちのビジョン',
        visionDesc: 'アジア最高の試験分析機関として成長し、グローバル品質標準をリードし、持続的な革新と発展を通じて業界のベンチマークになることです。',
        values: '核心価値',
        value1: '正確性',
        value1Desc: '精密な分析と信頼できる結果でお客様の信頼を獲得します',
        value2: '専門性',
        value2Desc: '豊富な経験と専門知識を基に最上のサービスを提供します',
        value3: '迅速性',
        value3Desc: '迅速な試験処理と報告書発行でお客様の時間を節約します',
        value4: '顧客中心',
        value4Desc: '顧客満足を最優先に考え、持続的な支援を提供します'
      },

      // History Section
      history: {
        badge: '会社沿革',
        title: '私たちの成長過程',
        subtitle: 'CTLの発展過程と主要成果を紹介します',
        year2026: '2026年 ~',
        event2026_1: 'CTL韓国支社・ベトナム試験所設立推進中',
        year2018: '2018年 ~',
        event2018_1: 'ISO/IEC 17025 公認試験機関 第4次試験項目拡大指定',
        event2018_2: '有害物質分析及び全分野生活消費財試験サービス拡大',
        year2017: '2017年 ~',
        event2017_1: 'ISO/IEC 17025 公認試験機関指定【ILAC / CNAS】',
        event2017_2: '1,200社以上の輸出企業及び30以上のグローバルバイヤーに公認試験サービス提供',
        year2016: '2016年 ~',
        event2016_1: '韓国ジュエリー共同研究院と表面処理等の共同研究開発協約締結',
        year2014: '2014年 ~',
        event2014_1: '中韓工芸品協会と業務協約(MOU)締結',
        year2012: '2012年 ~',
        event2012_1: '第三者独立法人試験所設立（中国青島・香港）',
        year2008: '2008年 ~',
        event2008_1: '企業内第二者試験所構築事業支援',
        event2008_2: '企業自社試験所運営指導のための中央試験所(Central Testing Lab)運営',
        year2007: '2007年 ~',
        event2007_1: '米国CPSIA及びEU REACH規制対応のためのHSPM有害物質管理システム構築',
        event2007_2: '輸出企業及びグローバルバイヤー向け規制対応技術支援提供'
      },

      // Services Section（ZH内容と同期）
      services: {
        badge: 'サービス',
        title: '総合試験ソリューション',
        subtitle: '化学分析、物理的特性、製品安全を網羅する専門試験サービス',

        service1Title: '化学試験',
        service1Item1: '有害物質分析',
        service1Item2: '金属/非金属/材料分析',
        service1Item3: '高分子/繊維分析',
        service1Item4: '玩具等消費財の衛生試験',
        service1Item5: '貴金属・宝飾品の試験分析',

        service2Title: '物理試験',
        service2Item1: '消費財安全評価試験',
        service2Item2: '信頼性試験',
        service2Item3: '表面処理耐久性評価試験',
        service2Item4: '繊維材料及び電気材料の難燃性試験',
        service2Item5: '環境疲労試験',

        service3Title: '製品安全',
        service3Item1: '貴金属・宝飾品の安全品質評価',
        service3Item2: '玩具等消費財の安全性評価',
        service3Item3: '家電製品の安全性評価',
        service3Item4: '国内外認証関連製品評価',
        service3Item5: '完全包装(内外)製品評価',

        service4Title: 'システム認証及び認証マーク',
        service4Item1: '貴金属品質認証',
        service4Item2: 'HSPM・有害物質管理',
        service4Item3: 'IATF16949認証コンサルティング',
        service4Item4: 'SAH安全衛生認証',
        service4Item5: '作業場環境評価',

        service5Title: '研究開発',
        service5Item1: '標準物質開発',
        service5Item2: '標準・仕様策定',
        service5Item3: '技術書籍発行',

        service6Title: '企業支援',
        service6Item1: '教育・研修',
        service6Item2: '企業実験室支援・中央実験室運営',
        service6Item3: '認証取得コンサルティング'
      },

      // Certifications Section
      certifications: {
        badge: '認証資格',
        title: '国際認証',
        subtitle: '主要国際機関の公認を受けた試験所',
        cert1Title: 'ISO/IEC 17025 認証',
        cert1Desc: '試験及び校正結果の正確性と信頼性を保証する国際的に認められた実験室品質管理システムです。',
        cert1Tag1: '国際標準',
        cert1Tag2: '品質保証',
        cert1Tag3: '信頼性',
        cert2Title: 'ILAC MRA 認定',
        cert2Desc: '国際試験所認定協力機構相互認定協定で、試験結果の全世界的受容を保証します。',
        cert2Tag1: 'グローバル認定',
        cert2Tag2: '相互認定',
        cert2Tag3: '国際協力',
        cert3Title: '米国CPSC認定',
        cert3Desc: '米国CPSC実験室認定を取得',
        cert3Tag1: 'CPSC認定',
        cert3Tag2: 'CPC作成',
        cert3Tag3: '国際協力',
        region1: '欧州標準',
        region2: '米国標準',
        region3: 'アジア標準',
        region4: '国際標準'
      },

      // Contact Section
      contact: {
        badge: 'お問い合わせ',
        title: '連絡先',
        subtitle: '試験プロジェクトを始める準備はできましたか？専門家チームにお問い合わせください。',

        infoTitle: '連絡先情報',
        phone: '電話',
        email: 'メール',
        address: '住所',
        addressLine1: '',
        addressLine2: '青島市城陽区書雲東路57号1号棟301室',
        hours: '営業時間',
        hoursWeekday: '月〜金: 08:00-18:00',
        hoursWeekend: '土曜日: 08:00-14:00',

        quickTitle: 'クイック相談',
        quickDesc: '緊急のお問い合わせがありますか？お電話で直接ご相談ください。',
        quickPhone: '相談電話',

        formTitle: 'お問い合わせフォーム',
        formName: 'お名前',
        formCompany: '会社名',
        formEmail: 'メールアドレス',
        formPhone: '電話番号',
        formService: 'サービス種類',
        formServicePlaceholder: 'サービスを選択してください',
        formServiceOption1: '化学分析',
        formServiceOption2: '物理的試験',
        formServiceOption3: '製品安全',
        formServiceOption4: '環境試験',
        formServiceOption5: '繊維試験',
        formServiceOption6: '食品安全',
        formServiceOption7: 'その他',
        formMessage: 'お問い合わせ内容',
        formMessagePlaceholder: 'お問い合わせ内容を入力してください（最大500文字）',
        formSubmit: 'お問い合わせ',
        formSuccess: 'お問い合わせが正常に送信されました！',
        formError: 'お問い合わせの送信中にエラーが発生しました。もう一度お試しください。'
      },

      // Equipment Section
      equipment: {
        badge: '設備',
        title: '検査設備',
        subtitle: '最新の分析設備と専門人員を配備し、正確で信頼できる検査結果を提供',
        applicationsLabel: '主要応用分野:'
      },

      // Announcements Page
      announcements: {
        badge: 'お知らせ',
        title: 'お知らせ',
        subtitle: '現在お知らせはありません',
        backToHome: 'ホームに戻る',
        emptyTitle: 'お知らせなし',
        emptyDesc: '現在お知らせはありません。後でもう一度ご確認ください。'
      },

      // Location Section
      location: {
        badge: 'アクセス',
        title: 'アクセス方法',
        subtitle: '便利な交通で簡単にお越しいただけます',
        subway: '地下鉄',
        subwayLine: '青島地下鉄1号線',
        subwayDesc: 'ハイテクゾーン駅下車後徒歩5分',
        subwayMapLink: '青島地下鉄路線図をクリックして表示',
        car: '自家用車',
        carParking: '無料駐車可能',
        carDesc: '',
        bus: 'バス',
        busLines: '111、131、946、4201番',
        busDesc: '太平庄駅下車、西へ900m'
      },

      // Footer
      footer: {
        description: 'ISO/IEC 17025認証を受けた国際公認試験所として最高水準の試験分析サービスを提供します。',
        servicesTitle: 'サービス',
        service1: '化学分析',
        service2: '物理的試験',
        service3: '製品安全',
        service4: '環境試験',
        quickLinksTitle: 'クイックリンク',
        contactTitle: '連絡先',
        copyright: '© 2024 青島試験所. All rights reserved.',
        poweredBy: 'ウェブサイトビルダー'
      },

      // Company submenu
      company: {
        info: '会社紹介',
        ceoMessage: 'CEO挨拶',
        history: '会社沿革'
      },

      // Company Info Page
      companyInfo: {
        badge: 'Company Info',
        title: '会社紹介',
        subtitle: '信頼と専門性でお客様の成功を支援する国際認定試験所',

        mainTitle: 'CTL（青島CTL検査技術サービス有限会社）',
        paragraph1: 'CTLは2012年に正式設立、2017年にCNAS及びILAC国際認定を取得した専門検査検査機関です。',
        paragraph2: 'CTLは模倣装身具、玩具、電子電気製品、繊維、皮革など多様な消費財分野の検査検査サービスを提供しており、欧州、米国、日本、韓国、中国など全世界を網羅するグローバルサービスネットワークを構築しています。また、中国国内の主要電子商取引プラットフォームとの戦略的協力を通じて産業全般の品質競争力向上に貢献しています。',
        paragraph3: '国際水準の先端検査設備と熟練した専門技術人材を基に、CTLは科学的公正性、正確性、効率性というサービス理念の下、国内外の検査規格と法規を厳格に遵守します。',
        paragraph4: 'お客様に信頼性の高い検査検査成績書を提供するだけでなく、各国の安全環境規制要求事項に対する検査分析及び技術支援を通じてグローバル市場進出と円滑な製品流通を支援しています。',
        paragraph5: 'CTLは企業の素材開発と品質管理全般にわたって共に成長する核心パートナーを志向します。',

        tag1: 'CNAS認証',
        tag2: 'ILAC MRA加盟',
        tag3: '国際認定',

        missionTitle: '私たちのミッション',
        missionDesc: '最高水準の検査分析サービスを通じてお客様の製品が全世界市場で安全に流通できるよう支援し、消費者の健康と安全を保護することに貢献します。',

        visionTitle: '私たちのビジョン',
        visionDesc: 'アジア最高の検査分析機関として成長し、グローバル品質標準をリードし、持続的な革新と発展を通じて業界のバンチマークになることです。',

        valuesTitle: '核心価値',
        value1Title: '正確性',
        value1Desc: '精密な分析と信頼できる結果でお客様の信頼を獲得',
        value2Title: '専門性',
        value2Desc: '豊富な経験と専門知識を基に最上のサービスを提供',
        value3Title: '迅速性',
        value3Desc: '迅速な検査処理と報告書発行でお客様の時間を節約',
        value4Title: '顧客中心',
        value4Desc: '顧客満足を最優先に考え、持続的な支援を提供',
        companyName: '青島検査技術サービス有限会社',

        stat1: '2015',
        stat1Label: '設立年度',
        stat2: '50+',
        stat2Label: '専門人材',
        stat3: '10,000+',
        stat3Label: '年間検査件数',
        stat4: '30+',
        stat4Label: '協力国家',

        ctaTitle: 'もっと詳しい情報が必要ですか？',
        ctaDesc: '専門相談員が貴社の要件を迅速に検討し、最適なソリューションを提案いたします',
        contactButton: 'お問い合わせ',
        servicesButton: 'サービスを見る'
      },

      // CEO Message Page (aligned with EN/ZH/KO CEO message content)
      ceoMessage: {
        badge: 'CEO Message',
        title: 'CTL 代表挨拶',
        subtitle: 'グローバル信頼を創る検査の基準',
        greeting: 'CTLはISO/IEC 17025国際規格に従って運営される認定試験・分析機関であり、CNAS認定及びILAC MRA国際相互承認を取得しています。',
        paragraph1: '国際水準の試験・分析機器と豊富な経験を有する専門人材を基に、正確で信頼性の高い試験・検査サービスを提供しており、CTLの試験結果と成績書は世界の主要国と市場で広く認められています。',
        paragraph2: '迅速な試験処理と体系的な報告書発行により、お客様の貴重な時間を節約し、合理的なコストで最高水準の品質を提供することを基本方針としています。また、継続的な技術支援と専門的なコンサルティングを通じて、お客様の持続的な成長を共に実現してまいります。',
        promiseTitle: '核心価値',
        promise1: '科学的公正性',
        promise2: '正確性',
        promise3: '効率性',
        promise4: '各国の安全・環境規制対応の積極的支援',
        paragraph3: 'CTLは単に試験結果を提供する機関にとどまりません。お客様の製品がグローバル市場で安全かつ円滑に流通するよう支援する、信頼されるパートナーとなることを目指しています。お客様の成功が私たちの成功であるという信念の下、すべての業務に最善を尽くしています。',
        paragraph4: '国別の商品関連規制に関する継続的な研究と専門性に基づき、「科学的公正性、正確性、効率性」を核心価値とし、各国の安全・環境規制対応を積極的に支援しています。特にジュエリー、児童用品及び各種消費財分野において、製品開発段階から世界市場での安全な流通に至るまで、お客様の長期的なグローバルパートナーとして継続的な支援を提供いたします。',
        paragraph5: '今後もCTLは継続的な技術開発と品質革新を通じて、アジアを超え世界を代表する試験・分析機関へと成長してまいります。お客様の変わらぬご関心とご支援を賜りますようお願い申し上げます。',
        closing: 'ありがとうございます。',
        ceoName: '金在明',
        ceoTitle: '代表取締役',
        companyName: 'CTL（青島CTL検査・技術サービス有限会社）',
        philosophyTitle: '経営哲学',
        value1Title: '公正性',
        value1Desc: '正確で公平な試験結果で顧客の信頼を獲得',
        value2Title: '正確性',
        value2Desc: '最高の専門人材と装置で信頼できる試験・分析を提供',
        value3Title: '効率性',
        value3Desc: '迅速・体系的なサービスで顧客の成功に貢献するパートナー',
        ctaTitle: '試験分析サービスが必要ですか？',
        ctaDescription: '専門相談員が貴社の要件を迅速に検討し、最適なソリューションを提案いたします',
        contactButton: 'お問い合わせ',
        servicesButton: 'サービスを見る',
        backToHome: 'ホームに戻る'
      },

      // Management Policy Page
      managementPolicy: {
        badge: 'Management Policy',
        title: '経営方針',
        subtitle: '顧客満足と品質優先のための私たちの経営哲学と方針',

        // Vision
        visionTitle: '経営ビジョン',
        visionDescription: 'グローバル試験認証分野の先導企業として、最高水準の技術力と信頼性を基に顧客の成功を支援し、産業発展に貢献します。',
        visionPoint1: '国際標準遵守及び持続的品質改善',
        visionPoint2: '顧客中心のカスタマイズサービス提供',
        visionPoint3: '技術革新と専門性強化',

        // Mission
        missionTitle: '経営ミッション',
        missionDescription: '正確で信頼できる試験サービスを通じて製品の安全性と品質を保証し、顧客のグローバル市場進出を積極的に支援します。',
        missionPoint1: 'ISO/IEC 17025基盤試験品質保証',
        missionPoint2: '迅速で正確な試験結果提供',
        missionPoint3: '専門技術コンサルティング及び支援',

        // ESH Social Responsibility
        eshTitle: '環境・安全・保健社会的責任',
        eshSubtitle: '環境保護、作業場安全、従業員健康を最優先とする社会的責任経営を実践します。',

        environmentTitle: '環境保護及び持続可能性',
        environmentPoint1: '環境に優しい試験方法及び装備導入',
        environmentPoint2: '化学物質及び廃棄物最小化',
        environmentPoint3: 'エネルギー効率化及び炭素排出削減',
        environmentPoint4: '環境経営システムISO 14001遵守',

        safetyTitle: '作業場安全管理',
        safetyPoint1: '定期的な安全教育及び訓練実施',
        safetyPoint2: '個人保護装備支給及び管理',
        safetyPoint3: '危険物質取扱安全手順遵守',
        safetyPoint4: '事故予防システム及び緊急対応体系',

        healthTitle: '従業員健康促進',
        healthPoint1: '定期健康検診及び特定健康検診',
        healthPoint2: '作業環境測定及び改善',
        healthPoint3: '筋骨格系疾患予防プログラム',
        healthPoint4: '従業員福祉及び健康促進プログラム',

        // Core Management Policies
        corePoliciesTitle: '核心経営方針',
        corePoliciesSubtitle: 'ISO/IEC 17025国際標準を遵守し、持続的品質改善を通じて最高水準の試験サービスを提供します。',

        qualityFirstTitle: '品質最優先',
        qualityFirstDesc: 'ISO/IEC 17025国際標準を遵守し、持続的品質改善を通じて最高水準の試験サービスを提供します。',

        customerSatisfactionTitle: '顧客満足',
        customerSatisfactionDesc: '顧客の要求事項を正確に把握し、迅速で正確なサービスで顧客満足を実現します。',

        expertiseTitle: '専門性強化',
        expertiseDesc: '持続的な教育と訓練を通じて専門人材を養成し、最新技術と知識を習得します。',

        environmentalTitle: '環境責任',
        environmentalDesc: '環境に優しい試験方法を導入し、持続可能な発展のために努力します。',

        innovationTitle: '技術革新',
        innovationDesc: '最先端装備と技術を導入して試験能力を持続的に向上させます。',

        globalCooperationTitle: 'グローバル協力',
        globalCooperationDesc: 'ILAC MRA認定を通じて国際的に認められる試験成績書を発行し、グローバルネットワークを構築します。',

        // Quality Management System
        qmsTitle: '品質経営システム',
        qmsSubtitle: 'ISO/IEC 17025基盤の体系的な品質経営システムを運営して試験の正確性と信頼性を保証します。',

        documentManagementTitle: '文書管理',
        documentManagementDesc: '体系的な文書管理システム',

        personnelManagementTitle: '人材管理',
        personnelManagementDesc: '専門人材教育及び資格管理',

        equipmentManagementTitle: '装備管理',
        equipmentManagementDesc: '定期的な校正及び維持補修',

        dataManagementTitle: 'データ管理',
        dataManagementDesc: '正確なデータ記録及び分析'
      },

      // Common
      common: {
        loading: '読み込み中...',
        error: 'エラーが発生しました',
        success: '成功',
        readMore: '続きを読む',
        learnMore: '詳細を見る',
        getStarted: '始める',
        contactUs: 'お問い合わせ',
        viewAll: 'すべて見る',
        backToHome: 'ホームに戻る'
      },

      // Business Page
      business: {
        badge: '主要業務',
        title: '主要業務',
        subtitle: 'CTLの多様な事業分野をご紹介します。',
        backToHome: 'ホームに戻る',
        laboratoryName: 'ISO 17025 試験室',
        laboratoryDesc: 'ILAC認定試験サービス',
        col1Header: '試験分析',
        col2Header: '製品適合性評価',
        col3Header: '製品検査',
        col4Header: 'System認証及び認証マーク',
        col5Header: '研究開発',
        col6Header: '企業支援',
        ctaTitle: '主要業務お問い合わせ',
        ctaDesc: '専門相談員が貴社の要件を迅速に確認し、最適なソリューションを提案いたします。',
        ctaPhone: 'カスタマーサービス',
        tableData: [
          { rowHeader: '材料/原材料分析', col1: ['ファッション・宝飾製品'], col2: ['製品品質検査'], col3: ['SA-8000'], col4: ['標準物開発'], col5: ['教育・研修'] },
          { rowHeader: '有害物質分析', col1: ['玩具、乳幼児用品、文具'], col2: ['工場監査'], col3: ['HSPM'], col4: ['標準・規格制定'], col5: ['コンサルティング支援'] },
          { rowHeader: '高分子材料', col1: ['衛生用品'], col2: ['On-site試験検査'], col3: ['ISO9000/140000'], col4: ['技術書籍発行'], col5: [] },
          { rowHeader: '貴金属材料分析', col1: ['繊維製品'], col2: [], col3: ['IATF-16949認証コンサルティング'], col4: [], col5: [] },
          { rowHeader: '金属/非金属/鉱物', col1: ['高齢者安全製品'], col2: [], col3: ['SAH安全衛生認証'], col4: [], col5: [] },
          { rowHeader: '表面処理/めっき液分析', col1: ['環境/安全/保健製品'], col2: [], col3: ['貴金属品質認証'], col4: [], col5: [] },
          { rowHeader: '繊維材料及び物性試験', col1: ['自動車電子電気部品試験'], col2: [], col3: ['作業場環境評価'], col4: [], col5: [] },
          { rowHeader: '物理強度及び疲労試験', col1: ['家電製品'], col2: [], col3: [], col4: [], col5: [] },
          { rowHeader: '信頼性試験', col1: ['完全包装(内外)製品評価'], col2: [], col3: [], col4: [], col5: [] },
          { rowHeader: '生活消費財関連試験', col1: ['国内外認証関連製品評価'], col2: [], col3: [], col4: [], col5: [] },
          { rowHeader: '環境衛生関連試験分析', col1: ['製品不良原因分析評価'], col2: [], col3: [], col4: [], col5: [] },
          { rowHeader: '包装材料試験', col1: [], col2: [], col3: [], col4: [], col5: [] },
          { rowHeader: '電子部品試験', col1: [], col2: [], col3: [], col4: [], col5: [] },
          { rowHeader: '微生物試験', col1: [], col2: [], col3: [], col4: [], col5: [] }
        ]
      },

      // Testing Analysis Page
      testingAnalysis: {
        badge: '主要業務',
        title: '試験/分析項目',
        subtitle: 'ISO 17025認証を受けた試験室で正確で信頼できる試験分析サービスを提供します。',
        backToHome: 'ホーム',
        laboratoryName: 'ISO 17025 試験室',
        laboratoryDesc: 'ILAC認定試験サービス',

        category1Title: '素材/材料分析',
        category1Items: ['金属/非金属', '鉱物質', '高分子材料', 'ガラス/セラミック材料', '貴金属分析'],

        category2Title: '有害物質分析',
        category2Items: [
          '重金属', 'フタル酸エステル', 'pH値', 'ホルムアルデヒド', '多環芳香族炭化水素',
          'アゾ染料', 'APEOs', 'フマル酸ジメチル (DMFuまたはDMF)', 'ビスフェノールA',
          '発がん性染料', '六価クロム', 'ペンタクロロフェノール', 'テトラクロロフェノール', '分散染料',
          '難燃剤', 'ニッケル溶出', 'ニトロソアミン',
          '有機スズ', 'パーフルオロ化合物', '溶剤'
        ],

        category3Title: '表面処理/めっき液試験',
        category3Items: ['金/銀', '貴金属含有量', 'めっき液分析'],

        category4Title: '物理試験',
        category4Items: ['引張強度', '硬度(HV)', '耐久性試験'],

        category5Title: '繊維試験',
        category5Items: ['難燃性試験', '30種以上の洗濯試験', '材料識別'],

        category6Title: '信頼性試験',
        category6Items: ['塩水噴霧試験', '環境老化試験', '耐摩耗試験', '光照射試験'],

        category7Title: '包装試験',
        category7Items: ['輸送試験', '落下試験', '破裂/エッジクラッシュ試験'],

        ctaTitle: '試験分析お問い合わせ',
        ctaDesc: '専門相談員が貴社の試験分析要件を詳しくご案内いたします。',
        ctaPhone: 'カスタマーサービス'
      },

      // Certifications Page
      certificationsPage: {
        badge: 'Certifications',
        title: '認証現況',
        subtitle: '国際的に認められた試験所認証及び資格現況',
        backToHome: 'ホーム',

        iso17025Title: 'ISO/IEC 17025',
        iso17025Desc: '試験及び校正試験所の適格性に関する国際標準認証を取得し、試験結果の正確性と信頼性が国際的に保証されています。',
        iso17025Tag1: '国際標準',
        iso17025Tag2: '品質保証',
        iso17025Tag3: '技術適格性',

        ilacTitle: 'ILAC MRA',
        ilacDesc: '国際試験所認定協力機構(ILAC)相互認定協定に加盟し、発行する試験成績書が世界中で認められています。',
        ilacTag1: 'グローバル認定',
        ilacTag2: '相互認定',
        ilacTag3: '国際協力',

        regionalTitle: '地域別認証現況',
        region1: 'European Regulations',
        region1Standards: ['REACH/UK REACH', 'ROHS/LVD Directives', 'GDPR/GPSR', 'Toy Safety Directives'],
        region2: 'USA Regulations',
        region2Standards: ['16 CFR CPSC/CPSIA', 'California & other State Law', '21CFR/29CFR', 'CPC/GPSC'],
        region3: 'Asia Regulations',
        region3Standards: ['GB & CCC', 'KS & KC/K-REACH', 'JIS & PSE/PSC', 'ASEAN Harmonized Standard'],
        region4: 'International Harmonized Regulations',
        region4Standards: ['IECEE CB Scheme', 'ISO/IEC', 'GHS', 'Codex Alimentarius'],

        certDetailsTitle: '認証詳細',
        chemicalCertTitle: '化学試験認証',
        chemicalCertItems: ['ICP-MS分析', 'GC-MS分析', 'LC-MS/MS分析', 'XRF分析'],

        physicalCertTitle: '物理試験認証',
        physicalCertItems: ['機械的特性', '熱分析', '電気的試験', '寸法測定'],

        safetyCertTitle: '製品安全認証',
        safetyCertItems: ['おもちゃ安全', '繊維安全', '電子製品安全', '食品接触材料'],

        envCertTitle: '環境試験認証',
        envCertItems: ['RoHS', 'REACH', 'Phthalates', 'VOC'],

        microCertTitle: '微生物試験認証',
        microCertItems: ['細菌検査', 'カビ検査', '酵母検査', '病原菌検査'],

        preciousCertTitle: '貴金属試験認証',
        preciousCertItems: ['金純度', '銀純度', '白金純度', 'ダイヤモンド鑑定'],

        // 実際の証明書情報
        actualCertsTitle: '保有証明書',
        cnasTitle: 'CNAS証明書',
        cnasNumber: '証明書番号: CNAS L10485',
        
        cpscCertTitle: 'CPSC 認定',
        cpscCertNumber: '会員番号: 1698'
      },

      // Industry Solutions Page
      industrySolutions: {
        badge: '顧客サポート',
        title: '業界別ソリューション',
        subtitle: '各業界分野の特性に合わせた専門的な試験、分析、認証ソリューションを提供します',
        servicesProvided: '提供サービス',
        ctaTitle: 'カスタマイズソリューションが必要ですか？',
        ctaDesc: '貴社の業界分野と製品特性に合った最適なソリューション을提案いたします',
        ctaButton: 'お問い合わせ',
        jewelry: {
          title: 'ジュエリー業界',
          description: '貴金属及び宝石類製品の品質保証と安全性確保のための総合ソリューション',
          service1: '貴金属純度分析（金、銀、白金など）',
          service2: '宝石鑑定及び品質評価',
          service3: '有害物質検査（ニッケル、カドミウム、鉛など）',
          service4: '物理的安全性試験',
          service5: '国際認証支援（REACH、RoHS）'
        },
        children: {
          title: '子供/乳幼児用品業界',
          description: '子供と乳幼児の安全を最優先とする専門試験及び認証ソリューション',
          service1: '物理的安全性試験（鋭い角、小さな部品）',
          service2: '化学的安全性試験（フタル酸エステル、重金属）',
          service3: '可燃性試験',
          service4: 'EN 71、ASTM F963、CPSIA認証支援',
          service5: '製品改善コンサルティング'
        },
        textile: {
          title: '繊維/衣類業界',
          description: '繊維製品の品質と安全性を保証する専門試験サービス',
          service1: '繊維成分分析',
          service2: '染色堅牢度試験',
          service3: '有害物質検査（アゾ染料、ホルムアルデヒド）',
          service4: '物理的性能試験（強度、耐久性）',
          service5: 'Oeko-Tex Standard 100認証支援'
        },
        cosmetics: {
          title: '化粧品業界',
          description: '化粧品の安全性と効能を検証する専門分析サービス',
          service1: '微生物試験（総菌数、大腸菌、緑膿菌）',
          service2: '重金属分析（鉛、ヒ素、水銀）',
          service3: '防腐剤及び保存剤分析',
          service4: '皮膚刺激試験',
          service5: 'ISO 22716（GMP）認証支援'
        },
        food: {
          title: '食品業界',
          description: '食品の安全性と品質を保証する総合分析サービス',
          service1: '栄養成分分析',
          service2: '微生物検査',
          service3: '残留農薬検査',
          service4: '重金属分析',
          service5: 'HACCP、ISO 22000認証支援'
        },
        electronics: {
          title: '電子/電気業界',
          description: '電子製品の安全性と性能を検証する専門試験サービス',
          service1: '電気安全性試験',
          service2: '有害物質検査（RoHS、REACH）',
          service3: 'EMC試験（電磁両立性）',
          service4: 'バッテリー安全性試験',
          service5: 'CE、FCC認証支援'
        },
        packaging: {
          title: '包装材業界',
          description: '包装材の安全性と環境親和性を検証する専門サービス',
          service1: '食品接触材料試験',
          service2: '重金属溶出試験',
          service3: '物理的性能試験',
          service4: '生分解性試験',
          service5: 'FDA、EU規定適合性評価'
        },
        medical: {
          title: '医療機器業界',
          description: '医療機器の安全性と効能を検証する専門試験サービス',
          service1: '生体適合性試験',
          service2: '滅菌検証',
          service3: '物理的/機械的性能試験',
          service4: '電気安全性試験',
          service5: 'ISO 13485、CE認証支援'
        }
      },

      // Jewelry Technical Center Page
      jewelryCenter: {
        badge: '技術センター（付属）',
        title: 'ジュエリー技術センター',
        subtitle: '貴金属及び宝石類製品の品質保証と安全性確保のための専門技術支援センター',
        servicesTitle: '専門試験サービス',
        servicesSubtitle: 'ジュエリー業界に特化した総合試験及び分析サービス',
        equipmentTitle: '専門装備',
        equipmentSubtitle: '最先端分析装備で正確な試験結果を提供',
        ctaTitle: 'ジュエリー試験が必要ですか？',
        ctaDesc: '専門技術陣が貴社の製品に最適化された試験ソリューションを提供します',
        ctaButton: 'お問い合わせ',
        service1: {
          title: '貴金属純度分析',
          description: '金、銀、白金など貴金属の正確な純度測定',
          item1: '金純度分析（K単位）',
          item2: '銀純度分析',
          item3: '白金純度分析',
          item4: '合金成分分析'
        },
        service2: {
          title: '宝石鑑定',
          description: 'ダイヤモンド及び各種宝石の品質評価',
          item1: 'ダイヤモンド4C評価',
          item2: 'カラーストーン鑑定',
          item3: '真珠品質評価',
          item4: '合成石鑑別'
        },
        service3: {
          title: '有害物質検査',
          description: '人体に有害な物質の含有量測定',
          item1: 'ニッケル溶出試験',
          item2: 'カドミウム検査',
          item3: '鉛含有量分析',
          item4: 'クロム検査'
        },
        service4: {
          title: '物理的安全性試験',
          description: '製品の耐久性及び安全性評価',
          item1: '鋭い角検査',
          item2: '小さな部品試験',
          item3: '引張強度試験',
          item4: '耐摩耗性試験'
        },
        service5: {
          title: '国際認証支援',
          description: '海外輸出のための認証取得支援',
          item1: 'REACH認証',
          item2: 'RoHS認証',
          item3: 'California Prop 65',
          item4: 'KC認証'
        },
        service6: {
          title: '品質保証書発行',
          description: '公信力のある品質保証書提供',
          item1: '純度保証書',
          item2: '鑑定書',
          item3: '試験成績書',
          item4: '適合性認証書'
        },
        equipment: {
          icpms: '微量元素分析',
          xrf: '非破壊成分分析',
          uvvis: '宝石分光分析',
          scale: '電子天秤',
          scaleDesc: '精密重量測定',
          hardness: '硬度計',
          hardnessDesc: '宝石硬度測定',
          microscope: '顕微鏡',
          microscopeDesc: '微細構造観察',
          refractometer: '屈折計',
          refractometerDesc: '宝石屈折率測定',
          spectrometer: '分光器',
          spectrometerDesc: '色相分析'
        }
      },

      // Children Baby Technical Center Page
      childrenCenter: {
        badge: '技術センター（付属）',
        title: '子供乳幼児用品技術センター',
        subtitle: '子供と乳幼児の安全を最優先とする専門試験及び技術支援センター',
        servicesTitle: '専門試験サービス',
        servicesSubtitle: '子供/乳幼児用品安全性評価のための総合試験サービス',
        productsTitle: '試験対象製品',
        productsSubtitle: '様々な子供/乳幼児用品に対する専門試験サービス',
        standardsTitle: '適用規格',
        standardsSubtitle: '国内外主要安全規格遵守',
        ctaTitle: '子供/乳幼児用品試験が必要ですか？',
        ctaDesc: '子供たちの安全のための専門的な試験サービスを提供します',
        ctaButton: 'お問い合わせ',
        service1: {
          title: '物理的安全性試験',
          description: '製品の物理的危険要素評価',
          item1: '鋭い角検査',
          item2: '小さな部品試験',
          item3: '引張強度試験',
          item4: '圧縮試験'
        },
        service2: {
          title: '化学的安全性試験',
          description: '有害化学物質含有量測定',
          item1: 'フタル酸エステル検査',
          item2: '重金属分析',
          item3: 'BPA検査',
          item4: 'ホルムアルデヒド測定'
        },
        service3: {
          title: '可燃性試験',
          description: '製品の火災安全性評価',
          item1: '繊維可燃性試験',
          item2: 'プラスチック可燃性試験',
          item3: '玩具可燃性試験',
          item4: '難燃性評価'
        },
        service4: {
          title: '微生物試験',
          description: '衛生及び微生物安全性評価',
          item1: '総菌数測定',
          item2: '大腸菌検査',
          item3: 'カビ検査',
          item4: 'サルモネラ検査'
        },
        service5: {
          title: '国際認証支援',
          description: '国内外安全認証取得支援',
          item1: 'KC認証',
          item2: 'EN 71',
          item3: 'ASTM F963',
          item4: 'CPSIA'
        },
        service6: {
          title: '製品改善コンサルティング',
          description: '安全性向上のための専門コンサルティング',
          item1: '設計改善提案',
          item2: '材料選択諮問',
          item3: '規格適合性検討',
          item4: 'アフターサポート'
        },
        product1: '玩具',
        product2: '乳児服',
        product3: 'ベビーカー',
        product4: 'チャイルドシート',
        product5: '哺乳瓶/乳首',
        product6: 'おむつ',
        product7: '寝具類',
        product8: '学用品',
        product9: '遊具',
        product10: '安全用品',
        product11: '食器類',
        product12: '入浴用品',
        region: {
          korea: '韓国',
          europe: '欧州',
          usa: '米国',
          china: '中国',
          international: '国際',
          japan: '日本',
          taiwan: '台湾'
        },
        standard1: '子供製品安全特別法',
        standard2: '玩具安全規格',
        standard3: '玩具安全規格',
        standard4: '消費者製品安全改善法',
        standard5: '玩具安全技術規範',
        standard6: '玩具安全国際標準',
        standard7: '日本産業規格',
        standard8: '中華民国国家標準'
      },

      // Education Center Page
      educationCenter: {
        badge: '顧客サポート',
        title: '教育センター',
        subtitle: '製品安全及び品質管理専門家養成のための体系的な教育プログラム',
        programsTitle: '教育プログラム',
        programsSubtitle: '実務中心の専門教育課程',
        benefitsTitle: '教育特典',
        benefitsSubtitle: '専門性向上とキャリア開発のための様々な特典',
        mainContent: '主要内容',
        ctaTitle: '教育申請お問い合わせ',
        ctaDesc: '貴社の教育要件に合わせたカスタマイズ教育プログラムを提供します',
        ctaButton: '教育申請',
        level: {
          beginner: '初級',
          intermediate: '中級',
          advanced: '上級'
        },
        program1: {
          title: '品質管理基礎課程',
          duration: '2日（16時間）',
          description: '品質管理の基本概念と実務適用方法',
          topic1: '品質管理概論',
          topic2: '統計的品質管理',
          topic3: '検査及び試験方法',
          topic4: '不良分析技法'
        },
        program2: {
          title: '製品安全規格課程',
          duration: '3日（24時間）',
          description: '国内外製品安全規格の理解と適用',
          topic1: 'KC認証制度',
          topic2: 'EN 71規格',
          topic3: 'ASTM規格',
          topic4: 'CPSIA規定'
        },
        program3: {
          title: '化学試験分析課程',
          duration: '5日（40時間）',
          description: '化学試験方法及び分析技術習得',
          topic1: 'ICP-MS分析',
          topic2: 'GC-MS分析',
          topic3: 'HPLC分析',
          topic4: '試料前処理'
        },
        program4: {
          title: '物理試験評価課程',
          duration: '3日（24時間）',
          description: '物理的試験方法及び評価技術',
          topic1: '機械的試験',
          topic2: '可燃性試験',
          topic3: '耐久性試験',
          topic4: '環境試験'
        },
        program5: {
          title: 'ISO 17025審査員課程',
          duration: '5日（40時間）',
          description: '試験所認定制度及び審査技法',
          topic1: 'ISO 17025要求事項',
          topic2: '内部審査技法',
          topic3: '是正措置',
          topic4: '文書管理'
        },
        program6: {
          title: '試験報告書作成課程',
          duration: '2日（16時間）',
          description: '専門的な試験報告書作成方法',
          topic1: '報告書構造',
          topic2: 'データ分析',
          topic3: '結果解釈',
          topic4: '不確かさ評価'
        },
        benefit1: {
          title: '修了証発行',
          desc: '公認された教育修了証提供'
        },
        benefit2: {
          title: '専門家講義',
          desc: '現場経験豊富な専門家講義'
        },
        benefit3: {
          title: '教育資料',
          desc: '実務に活用可能な教育資料提供'
        },
        benefit4: {
          title: 'アフターサポート',
          desc: '教育後持続的な技術支援'
        }
      },

      // Regulation Research Page
      regulationResearch: {
        badge: '顧客サポート',
        title: '法令研究/規格開発',
        subtitle: '国内外法令研究及び産業標準開発を通じた企業競争力強化支援',
        servicesTitle: '主要サービス',
        servicesSubtitle: '法令研究及び規格開発専門サービス',
        areasTitle: '研究分野',
        areasSubtitle: '様々な産業分野の法令及び規格研究',
        benefitsTitle: '期待効果',
        benefitsSubtitle: '法令研究及び規格開発を通じた企業価値向上',
        ctaTitle: '法令研究及び規格開発お問い合わせ',
        ctaDesc: '専門家チームが貴社の規制対応及び標準化戦略を支援します',
        ctaButton: 'お問い合わせ',
        service1: {
          title: '法令研究及び分析',
          description: '国内外製品安全関連法令の体系的研究及び分析',
          item1: '国内法令モニタリング及び分析',
          item2: '海外規制動向調査',
          item3: '法令改正影響評価',
          item4: '規制対応戦略樹立',
          item5: '法令解釈及び諮問'
        },
        service2: {
          title: '産業標準開発',
          description: '産業発展のための標準及び規格開発',
          item1: 'KS標準開発支援',
          item2: '団体標準制定',
          item3: '試験方法標準化',
          item4: '品質基準設定',
          item5: '標準普及及び教育'
        },
        service3: {
          title: '国際規格対応',
          description: '国際標準及び規格に対する専門的対応',
          item1: 'ISO/IEC標準研究',
          item2: 'ASTM規格分析',
          item3: 'EN規格対応',
          item4: '国際標準化活動参加',
          item5: '海外認証支援'
        },
        service4: {
          title: '規制適合性評価',
          description: '製品の法令及び規格適合性総合評価',
          item1: '法令適合性検討',
          item2: '規格遵守可否評価',
          item3: '改善方案提示',
          item4: '認証取得支援',
          item5: 'アフター管理コンサルティング'
        },
        area1: {
          title: '子供/乳幼児用品',
          desc: '玩具及び子供製品安全規制'
        },
        area2: {
          title: 'ジュエリー',
          desc: '貴金属及び宝石類品質基準'
        },
        area3: {
          title: '繊維/衣類',
          desc: '繊維製品安全及び品質規格'
        },
        area4: {
          title: '化粧品',
          desc: '化粧品安全基準及び表示規定'
        },
        area5: {
          title: '食品',
          desc: '食品安全管理及び表示基準'
        },
        area6: {
          title: '電子/電気',
          desc: '電気用品安全管理規定'
        },
        benefit1: {
          title: '規制リスク最小化',
          desc: '法令違反によるリスク事前予防'
        },
        benefit2: {
          title: '市場参入加速化',
          desc: '迅速な認証取得で市場参入短縮'
        },
        benefit3: {
          title: '競争力強化',
          desc: '標準先導を通じた市場競争力確保'
        },
        benefit4: {
          title: '海外進出支援',
          desc: '国際規格対応で輸出拡大'
        }
      },

      // Test Guides Page
      testGuides: {
        badge: '試験ガイド',
        title: '試験ガイド',
        subtitle: '各種試験項目別の詳細ガイドと手順ガイドを提供します。必要な資料をダウンロードしてご利用ください。',
        backToHome: 'ホームに戻る',
        companyName: '青島検査技術サービス有限会社',
        ctaTitle: '追加のお問い合わせが必要ですか？',
        ctaDesc: '資料に関するお問い合わせや追加情報が必要な場合は、いつでもご連絡ください。',
        ctaButton: 'お問い合わせ',
        guides: {
          chemical: {
            title: '化学試験ガイド',
            description: '化学分析試験の全体的な手順と方法を案内します。',
            files: [
              { name: '重金属分析ガイド.pdf', size: '2.5 MB', date: '2024-01-15' },
              { name: '有害物質検査マニュアル.pdf', size: '3.2 MB', date: '2024-01-10' },
              { name: '化学成分分析手順.pdf', size: '1.8 MB', date: '2024-01-05' }
            ]
          },
          physical: {
            title: '物理試験ガイド',
            description: '物理的特性試験の方法と基準を説明します。',
            files: [
              { name: '強度試験ガイド.pdf', size: '2.1 MB', date: '2024-01-20' },
              { name: '耐久性テストマニュアル.pdf', size: '2.8 MB', date: '2024-01-18' },
              { name: '物理的特性分析.pdf', size: '1.5 MB', date: '2024-01-12' }
            ]
          },
          quality: {
            title: '品質検査ガイド',
            description: '製品品質検査の基準と手順を案内します。',
            files: [
              { name: '品質管理ガイド.pdf', size: '3.5 MB', date: '2024-01-25' },
              { name: '検査基準書.pdf', size: '2.2 MB', date: '2024-01-22' },
              { name: '不良判定マニュアル.pdf', size: '1.9 MB', date: '2024-01-15' }
            ]
          },
          environmental: {
            title: '環境試験ガイド',
            description: '環境条件試験の方法と基準を提供します。',
            files: [
              { name: '温湿度試験ガイド.pdf', size: '2.4 MB', date: '2024-01-28' },
              { name: '環境耐久性テスト.pdf', size: '3.1 MB', date: '2024-01-24' },
              { name: '気候試験手順.pdf', size: '2.0 MB', date: '2024-01-20' }
            ]
          },
          electrical: {
            title: '電気安全試験ガイド',
            description: '電気安全関連試験の手順と基準を説明します。',
            files: [
              { name: '電気安全ガイド.pdf', size: '2.7 MB', date: '2024-02-01' },
              { name: '絶縁試験マニュアル.pdf', size: '2.3 MB', date: '2024-01-30' },
              { name: '電圧テスト手順.pdf', size: '1.7 MB', date: '2024-01-28' }
            ]
          },
          sample: {
            title: '試料準備ガイド',
            description: '試験試料の準備と保管方法を案内します。',
            files: [
              { name: '試料採取ガイド.pdf', size: '2.0 MB', date: '2024-02-03' },
              { name: '試料保管マニュアル.pdf', size: '1.6 MB', date: '2024-02-01' },
              { name: '前処理手順書.pdf', size: '2.2 MB', date: '2024-01-29' }
            ]
          }
        }
      },

      // Certificates Page
      certificates: {
        badge: '証明書サンプル',
        title: '証明書サンプル',
        subtitle: '試験成績書サンプルおよび各種証明書サンプルを確認できます。画像をクリックすると拡大してご覧いただけます。',
        backToHome: 'ホームに戻る',
        companyName: '青島検査技術サービス有限会社',
        download: 'ダウンロード',
        issueDate: '発行日',
        validUntil: '有効期限',
        ctaTitle: '証明書発行お問い合わせ',
        ctaDesc: '試験成績書発行や証明書に関するお問い合わせがある場合は、いつでもご連絡ください。',
        ctaButton: 'お問い合わせ',
        certs: {
          iso17025: {
            title: 'ISO/IEC 17025 証明書',
            description: '国際公認試験機関証明書'
          },
          ilac: {
            title: 'ILAC MRA 認定書',
            description: 'ILAC 相互認定協定認定書'
          },
          testReport: {
            title: '試験成績書サンプル',
            description: '化学分析試験成績書例'
          },
          qms: {
            title: '品質管理証明書',
            description: 'ISO 9001 品質管理システム認証'
          },
          ems: {
            title: '環境管理証明書',
            description: 'ISO 14001 環境管理システム認証'
          },
          ohsms: {
            title: '安全衛生証明書',
            description: 'ISO 45001 安全衛生管理システム認証'
          }
        }
      },

      // Hazardous Limits Page
      hazardousLimits: {
        badge: '有害物質規制基準',
        title: '各国有害物質許容基準',
        subtitle: '米国、欧州、ドイツ、中国の主要有害物質規制基準と許容限界を確認してください。各国の規制機関と公式出典情報を提供します。',
        backToHome: 'ホームに戻る',
        companyName: '青島検査技術サービス有限会社',
        countries: {
          usa: '米国',
          eu: '欧州',
          germany: 'ドイツ',
          china: '中国'
        },
        agenciesTitle: '主要規制機関',
        standardsTitle: '基準',
        substance: '物質名',
        limit: '許容基準',
        application: '適用対象',
        source: '出典/規制',
        referencesTitle: '公式出典および参考資料',
        noticeTitle: '重要なお知らせ',
        noticeItems: [
          '本資料は参考用であり、実際の試験および認証時には最新の規制を確認してください。',
          '規制基準は随時更新されるため、公式出典を通じて最新情報を確認してください。',
          '製品によって適用される規制が異なる場合があるため、専門家にご相談ください。',
          '試験依頼前に該当国の最新規制要件を確認してください。'
        ],
        ctaTitle: '有害物質試験が必要ですか？',
        ctaDesc: '各国の規制基準に準拠した正確な試験サービスを提供します。専門コンサルタントがお手伝いします。',
        ctaButton1: '試験お問い合わせ',
        ctaButton2: '電話相談'
      },

      // International Standards Page
      internationalStandards: {
        badge: 'International Standards',
        title: '国際規格および認証',
        subtitle: 'ISO、IEC、ILAC MRA、OECD GLPなど国際的に認められた標準規格に従って試験分析サービスを提供します',
        backToHome: 'ホームに戻る',
        companyName: '青島検査技術サービス有限会社',
        isoTitle: 'ISO/IEC 17025',
        isoDesc: '国際標準化機構(ISO)と国際電気標準会議(IEC)が共同で制定した試験および校正機関の資格に関する国際標準です。',
        isoPoints: [
          '試験所の技術的能力の証明',
          '品質管理システムの運営',
          '正確で信頼できる結果の提供',
          '国際的に認められた試験成績書の発行'
        ],
        isoRequirements: {
          title: 'ISO 17025 主要要求事項',
          management: {
            title: '管理要求事項',
            items: ['組織構造', '文書管理', '内部監査', '是正措置']
          },
          technical: {
            title: '技術要求事項',
            items: ['人員資格', '施設環境', '試験方法', '設備管理']
          },
          quality: {
            title: '品質保証',
            items: ['結果品質', 'データ整合性', '報告書発行', '顧客満足']
          }
        },
        iecTitle: 'IEC 国際電気標準',
        iecDesc: '国際電気標準会議(IEC)が制定した電気・電子製品の安全性および性能に関する国際標準を遵守します。',
        iecStandards: [
          { code: 'IEC 60068', name: '環境試験' },
          { code: 'IEC 62368', name: '電気安全' },
          { code: 'IEC 61000', name: 'EMC試験' },
          { code: 'IEC 62133', name: 'バッテリー安全' }
        ],
        ilacTitle: 'ILAC 相互認定協定',
        ilacDesc: '国際試験所認定協力機構(ILAC)の相互認定協定(MRA)を通じて、世界100カ国以上で試験結果が認められています。',
        ilacBenefits: [
          { title: '国際的認証', description: '100カ国以上で試験結果が認められる' },
          { title: '信頼性保証', description: '国際標準に基づく品質保証' },
          { title: '重複試験防止', description: '一度の試験で世界中で有効' }
        ],
        ilacCountries: 'ILAC MRA 加盟国',
        ilacCountriesDesc: 'アジア、欧州、北米、南米、アフリカ、オセアニアなど世界の主要国がILAC MRAに加盟し、相互に試験結果を認めています。',
        oecdTitle: 'OECD 優良実験所運営基準',
        oecdDesc: '経済協力開発機構(OECD)のGood Laboratory Practice基準に従って化学物質安全性試験を実施します。',
        oecdItems: [
          { title: '組織および人員', description: '適格な人員と明確な責任体制' },
          { title: '品質保証プログラム', description: '独立した品質保証システムの運営' },
          { title: '施設および設備', description: '適切な施設と検証された設備の使用' },
          { title: '試験手順', description: '標準作業手順書(SOP)に従った試験実施' }
        ],
        benefitsTitle: '国際規格遵守の利点',
        benefitsDesc: '国際的に認められた標準に従った試験により、さまざまな利点を得ることができます',
        benefits: [
          { title: '輸出入簡素化', description: '国際的に認められた試験成績書で通関手続きを簡素化' },
          { title: '信頼性向上', description: '国際規格遵守により製品信頼性およびブランド価値を向上' },
          { title: 'コスト削減', description: '重複試験を防ぐことで時間とコストを節約' },
          { title: '市場アクセス性', description: '世界市場参入の必須要件を満たす' },
          { title: '法的保護', description: '国際規制遵守により法的リスクを最小化' },
          { title: '顧客満足', description: '信頼できる試験結果により顧客満足度を向上' }
        ],
        ctaTitle: '国際規格試験が必要ですか？',
        ctaDesc: 'ISO 17025認証試験所で国際的に認められた試験サービスを提供します',
        ctaButton1: 'お問い合わせ',
        ctaButton2: 'ホームに戻る',
        countries: ['韓国', '米国', '日本', '中国', 'ドイツ', '英国', 'フランス', 'カナダ', 'オーストラリア', 'シンガポール']
      },

      // Inquiry Page
      inquiry: {
        badge: '顧客サポート',
        title: 'お問い合わせ',
        subtitle: '試験に関するお問い合わせやご質問がある場合は、メッセージを残してください。すぐに返信いたします。',
        backToHome: 'ホームに戻る',
        companyName: 'ISO 17025 Testing Laboratory',
        companySubtitle: 'ILAC Accredited Testing Services',
        tabs: {
          form: 'お問い合わせ作成',
          list: 'お問い合わせ履歴'
        },
        formTitle: 'お問い合わせ作成',
        formSubtitle: 'お問い合わせ内容を詳しく記入してください',
        successTitle: 'お問い合わせが正常に受付されました！',
        successDesc: 'できるだけ早く返信いたします。',
        fields: {
          name: 'お名前',
          nameRequired: 'お名前 *',
          company: '会社名',
          email: 'メールアドレス',
          emailRequired: 'メールアドレス *',
          phone: '連絡先',
          phoneRequired: '連絡先 *',
          inquiryType: 'お問い合わせ種類',
          inquiryTypeRequired: 'お問い合わせ種類 *',
          inquiryTypePlaceholder: 'お問い合わせ種類を選択してください',
          message: 'お問い合わせ内容',
          messageRequired: 'お問い合わせ内容 *',
          messagePlaceholder: 'お問い合わせ内容を詳しく記入してください（最大500文字）',
          submit: 'お問い合わせ送信'
        },
        inquiryTypes: {
          test: '試験お問い合わせ',
          certificate: '証明書お問い合わせ',
          cost: '費用お問い合わせ',
          schedule: 'スケジュールお問い合わせ',
          technical: '技術お問い合わせ',
          other: 'その他お問い合わせ'
        },
        privacyTitle: '個人情報の収集および利用に関するお知らせ',
        privacyDesc: 'お問い合わせ処理のため、お名前、メールアドレス、連絡先情報が収集され、回答完了後3ヶ月間保存されます。',
        listTitle: 'お問い合わせ履歴',
        listSubtitle: '受付されたお問い合わせ履歴を確認できます',
        loading: 'お問い合わせ履歴を読み込んでいます...',
        emptyTitle: 'お問い合わせ履歴がありません',
        emptyDesc: '最初のお問い合わせを作成してください！',
        emptyButton: 'お問い合わせ作成',
        status: {
          answered: '回答済み',
          pending: '回答待ち'
        },
        viewDetails: '詳細を表示するにはクリック',
        collapse: '折りたたむ',
        inquiryContent: 'お問い合わせ内容',
        answerPending: '回答待ちです',
        answerPendingDesc: 'できるだけ早く返信いたします。',
        ctaTitle: '緊急のお問い合わせが必要ですか？',
        ctaDesc: '緊急の場合は、電話でお問い合わせいただければ、すぐにご相談いたします。',
        ctaPhone: 'カスタマーサービス電話',
        ctaPhoneNumber: '0532-55566163/55566165',
        footerEmail: 'メール',
        footerEmailValue: 'ctl@centrallab.biz'
      },

      // NotFound Page
      notFound: {
        title: 'This page has not been generated',
        subtitle: 'Tell me more about this page, so I can generate it'
      },

      // Product Testing Page
      productTesting: {
        badge: '主要業務',
        title: '製品適合性評価',
        subtitle: '様々な製品群に対する専門的な試験評価サービスを提供します。国際規格に従った正確で信頼できる試験結果を保証します。',
        backToHome: 'ホームに戻る',
        companyName: '青島検査技術サービス有限会社',
        categoriesTitle: '製品カテゴリー',
        categoriesSubtitle: '各製品群に特化した試験サービスを提供します',
        whyTitle: 'なぜ私たちを選ぶべきか？',
        whySubtitle: '専門性と信頼性に基づいて最高水準の試験サービスを提供します',
        processTitle: '試験進行プロセス',
        processSubtitle: '体系的なプロセスを通じて正確な試験結果を提供します',
        ctaTitle: '試験お問い合わせが必要ですか？',
        ctaDesc: '専門コンサルタントがお客様の製品に最適な試験方法をご案内します。',
        ctaButton1: 'オンラインお問い合わせ',
        ctaButton2: '電話お問い合わせ',
        ctaPhone: '電話お問い合わせ',
        ctaPhoneNumber: '0532-55566163/55566165',
        viewTests: '試験項目を見る',
        applicableStandards: '適用規格',
        features: [
          { title: 'ISO/IEC 17025 認証', description: '国際的に認められた公認試験所', icon: 'ri-award-line' },
          { title: '最新試験設備', description: '先端分析設備による精密試験', icon: 'ri-microscope-line' },
          { title: '専門人員', description: '豊富な経験を持つ専門試験人員', icon: 'ri-team-line' },
          { title: '迅速な処理', description: '迅速な試験進行と結果提供', icon: 'ri-time-line' }
        ],
        processSteps: [
          { step: '01', title: 'お問い合わせ受付', description: '製品情報および試験要件の確認', icon: 'ri-customer-service-line' },
          { step: '02', title: '見積提供', description: '試験項目別の詳細見積案内', icon: 'ri-file-list-line' },
          { step: '03', title: '試料受付', description: '試料受領および試験準備', icon: 'ri-inbox-line' },
          { step: '04', title: '試験実施', description: '専門設備を活用した精密試験', icon: 'ri-flask-line' },
          { step: '05', title: '結果発行', description: '試験成績書発行および納品', icon: 'ri-file-text-line' }
        ],
        categories: [
          {
            id: 'jewelry',
            name: 'ジュエリー',
            description: '貴金属および宝石類の品質と安全性を検証します',
            tests: [
              { category: '成分分析', items: ['貴金属純度分析', '合金成分分析', 'めっき層厚さ測定', '宝石鑑定'] },
              { category: '有害物質検査', items: ['鉛(Pb)', 'カドミウム(Cd)', 'ニッケル溶出', '6価クロム'] },
              { category: '物理的試験', items: ['耐摩耗性', '耐腐食性', 'めっき密着力', '引張強度'] }
            ],
            standards: ['US CPSC/CPSIA', 'US State Law', 'EU REACH', 'GB', 'KC', 'SAH認証規格', '925 Silver', '貴金属Labeling規定']
          },
          {
            id: 'children',
            name: '子供用品',
            description: '子供製品の安全性と品質を徹底的に検査します',
            tests: [
              { category: '物理的安全性', items: ['小さな部品', '鋭い先端', '落下試験', '圧縮試験', '引張試験', 'ねじり試験'] },
              { category: '化学的安全性', items: ['重金属8種', 'フタル酸エステル6種', 'アゾ染料', 'BPA', 'ホルムアルデヒド'] },
              { category: '可燃性試験', items: ['繊維可燃性', 'プラスチック可燃性'] }
            ],
            standards: ['ASTM F963', 'EN 71', 'GB 6675', 'CPSIA', 'ISO 8124']
          },
          {
            id: 'baby',
            name: '乳幼児用品',
            description: '乳幼児製品の安全性を最優先に検証します',
            tests: [
              { category: '物理的安全性', items: ['窒息危険', '鋭い部分', '挟み込み危険', '安定性試験'] },
              { category: '化学的安全性', items: ['重金属', 'フタル酸エステル', 'BPA', 'ホルムアルデヒド', 'VOCs'] },
              { category: '微生物試験', items: ['総好気性生菌数', '大腸菌群', '黄色ブドウ球菌', '緑膿菌'] }
            ],
            standards: ['ASTM F2194', 'EN 14372', 'GB 28482', 'CPSIA', 'FDA']
          },
          {
            id: 'stationery',
            name: '文具用品',
            description: '学生用文具類の安全性と品質を評価します',
            tests: [
              { category: '化学的安全性', items: ['重金属8種', '芳香族アミン', 'フタル酸エステル', 'ホルムアルデヒド'] },
              { category: '物理的安全性', items: ['鋭い先端', 'キャップ安全性', 'ペン先安全性'] },
              { category: '性能試験', items: ['筆記性能', '消しゴム性能', '接着力', '耐水性'] }
            ],
            standards: ['EN 71-3', 'ASTM D4236', 'GB 21027', 'ISO 11540']
          },
          {
            id: 'hygiene',
            name: '衛生用品',
            description: '衛生用品の安全性と効能を検証します',
            tests: [
              { category: '微生物試験', items: ['総好気性生菌数', '大腸菌', '緑膿菌', '黄色ブドウ球菌', 'カビ'] },
              { category: '化学的安全性', items: ['重金属', 'メタノール', 'ホルムアルデヒド', '防腐剤', 'pH'] },
              { category: '効能試験', items: ['抗菌効果', '殺菌効果', '清浄力'] }
            ],
            standards: ['GB 15979', 'ISO 22196', 'ASTM E2149', 'FDA']
          },
          {
            id: 'safety',
            name: '安全用品',
            description: '個人保護設備の安全性と性能を評価します',
            tests: [
              { category: '物理的性能', items: ['衝撃吸収', '貫通抵抗', '引張強度', '耐摩耗性'] },
              { category: '化学的安全性', items: ['有害物質', 'pH', '皮膚刺激性'] },
              { category: '機能性試験', items: ['防水性', '通気性', '難燃性', '耐熱性'] }
            ],
            standards: ['EN 420', 'ANSI Z87.1', 'EN 388', 'ISO 20345', 'GB 2626']
          },
          {
            id: 'textile',
            name: '繊維用品',
            description: '繊維製品の品質と安全性を総合的に評価します',
            tests: [
              { category: '化学的安全性', items: ['アゾ染料', 'ホルムアルデヒド', 'pH', '重金属', 'アレルギー染料', 'DMFu'] },
              { category: '物理的性能', items: ['引張強度', '引裂強度', '摩耗抵抗性', 'ピリング試験', '寸法変化率'] },
              { category: '機能性試験', items: ['洗濯堅牢度', '汗堅牢度', '摩擦堅牢度', '日光堅牢度', '防水性', '通気性'] },
              { category: '可燃性試験', items: ['繊維可燃性', '難燃性評価'] }
            ],
            standards: ['OEKO-TEX Standard 100', 'GB 18401', 'REACH', 'CPSIA', 'EN 14682', 'ASTM D4966', 'ISO 105']
          },
          {
            id: 'electrical',
            name: '家庭用電気製品',
            description: '家電製品の電気安全性と性能を検証します',
            tests: [
              { category: '電気安全性', items: ['絶縁抵抗', '耐電圧', '接地連続性', '漏れ電流', '温度上昇'] },
              { category: '機械的安全性', items: ['構造検査', '機械的強度', '安定性試験', '落下試験'] },
              { category: '化学的安全性', items: ['有害物質(RoHS)', '難燃性', 'PAHs', 'フタル酸エステル'] },
              { category: 'EMC試験', items: ['電磁適合性', '電磁放出', '電磁耐性'] }
            ],
            standards: ['IEC 60335', 'GB 4706', 'UL 1026', 'EN 60335', 'KC認証', 'CE認証', 'RoHS', 'REACH']
          },
          {
            id: 'game',
            name: 'ゲーム',
            description: 'ゲーム製品の安全性と品質を評価します',
            tests: [
              { category: '物理的安全性', items: ['小さな部品', '鋭い先端', '落下試験', '圧縮試験'] },
              { category: '化学的安全性', items: ['重金属', 'フタル酸エステル', 'PAHs', 'アゾ染料'] }
            ],
            standards: ['ASTM F963', 'EN 71', 'GB 6675', 'CPSIA']
          },
          {
            id: 'silver',
            name: 'Silver用品',
            description: 'Silver製品の純度と品質を検証します',
            tests: [
              { category: '成分分析', items: ['Silver純度分析', '合金成分分析', 'めっき層分析'] },
              { category: '有害物質検査', items: ['鉛(Pb)', 'カドミウム(Cd)', 'ニッケル溶出', '重金属'] },
              { category: '物理的試験', items: ['耐摩耗性', '耐腐食性', 'めっき密着力'] }
            ],
            standards: ['925 Silver', 'US CPSC', 'EU REACH', 'GB', 'KC']
          },
          {
            id: 'furniture',
            name: '室内家具製品',
            description: '室内家具の安全性と耐久性を評価します',
            tests: [
              { category: '物理的安全性', items: ['安定性試験', '耐久性試験', '落下試験', '荷重試験'] },
              { category: '化学的安全性', items: ['ホルムアルデヒド', 'VOCs', '重金属', '難燃性'] },
              { category: '材料試験', items: ['木材強度', '接着剤性能', '表面仕上げ', '耐摩耗性'] }
            ],
            standards: ['EN 12520', 'BIFMA', 'GB 28007', 'CARB', 'REACH']
          },
          {
            id: 'packaging',
            name: '包装物(内外包装)',
            description: '包装材の安全性と性能を検証します',
            tests: [
              { category: '物理的試験', items: ['圧縮強度', '落下試験', '振動試験', '衝撃試験'] },
              { category: '化学的安全性', items: ['重金属', 'フタル酸エステル', 'PAHs', '食品接触物質'] },
              { category: '性能試験', items: ['防水性', '耐熱性', '密封性能', '印刷品質'] }
            ],
            standards: ['ISTA', 'ASTM D4169', 'ISO 12048', 'GB/T 4857', 'FDA', 'EU 10/2011']
          }
        ]
      },


      // Certification Support Page
      certificationSupport: {
        badge: '顧客サポート',
        title: '認証制度サポート(分野別)',
        subtitle: '各分野の国内外認証制度に対する専門的なコンサルティングと試験サービスを提供します',
        backToHome: 'ホームに戻る',
        processTitle: '認証サポートプロセス',
        processSubtitle: '体系的なプロセスを通じて認証取得を支援します',
        ctaTitle: '認証関連のお問い合わせがありますか？',
        ctaDesc: '専門コンサルタントが貴社の製品に必要な認証をご案内します',
        ctaButton: 'お問い合わせ',
        processSteps: [
          { step: '1', title: '相談および分析', desc: '製品および認証要件の分析', icon: 'ri-discuss-line' },
          { step: '2', title: '試験計画', desc: '必要な試験項目およびスケジュールの確立', icon: 'ri-file-list-line' },
          { step: '3', title: '試験実施', desc: '国際標準に従った精密試験', icon: 'ri-test-tube-line' },
          { step: '4', title: '報告書発行', desc: '試験結果報告書の作成', icon: 'ri-file-text-line' },
          { step: '5', title: '認証サポート', desc: '認証機関への提出および事後管理', icon: 'ri-award-line' }
        ],
        certifications: {
          children: {
            title: '子供/乳幼児用品認証',
            description: '子供と乳幼児の安全を保証する国内外認証サポート',
            standards: [
              { name: 'KC認証', desc: '韓国子供製品安全特別法認証' },
              { name: 'EN 71', desc: '欧州玩具安全規格' },
              { name: 'ASTM F963', desc: '米国玩具安全規格' },
              { name: 'CPSIA', desc: '米国消費者製品安全改善法' },
              { name: 'GB 6675', desc: '中国玩具安全技術規範' }
            ]
          },
          jewelry: {
            title: 'ジュエリー認証',
            description: '貴金属および宝石類の品質と安全性を保証する認証',
            standards: [
              { name: 'KC認証', desc: '韓国貴金属および宝石類品質認証' },
              { name: 'REACH', desc: '欧州化学物質規制' },
              { name: 'RoHS', desc: '有害物質使用制限指令' },
              { name: 'California Prop 65', desc: 'カリフォルニア有害物質警告規定' },
              { name: 'Nickel Release', desc: 'ニッケル溶出試験' }
            ]
          },
          textile: {
            title: '繊維/衣類認証',
            description: '繊維製品の安全性と品質を認証する国際標準',
            standards: [
              { name: 'Oeko-Tex Standard 100', desc: '有害物質検査認証' },
              { name: 'GOTS', desc: '有機繊維国際認証' },
              { name: 'REACH', desc: '欧州化学物質規制' },
              { name: 'KC認証', desc: '韓国繊維製品品質認証' },
              { name: 'CPSIA', desc: '米国消費者製品安全法' }
            ]
          },
          cosmetics: {
            title: '化粧品認証',
            description: '化粧品の安全性と効能を検証する認証制度',
            standards: [
              { name: 'ISO 22716', desc: '化粧品GMP国際標準' },
              { name: 'CPNP', desc: '欧州化粧品申告ポータル' },
              { name: 'FDA登録', desc: '米国食品医薬品局登録' },
              { name: 'CFDA', desc: '中国食品医薬品監督管理局認証' },
              { name: 'KC認証', desc: '韓国化粧品安全基準' }
            ]
          },
          food: {
            title: '食品認証',
            description: '食品の安全性と品質を保証する認証システム',
            standards: [
              { name: 'HACCP', desc: '食品安全管理認証' },
              { name: 'ISO 22000', desc: '食品安全経営システム' },
              { name: 'FSSC 22000', desc: '食品安全システム認証' },
              { name: 'Halal', desc: 'ハラル認証' },
              { name: 'Kosher', desc: 'コーシャ認証' }
            ]
          },
          electronics: {
            title: '電子/電気認証',
            description: '電子製品の安全性と性能を検証する国際認証',
            standards: [
              { name: 'CEマーク', desc: '欧州製品安全認証' },
              { name: 'FCC', desc: '米国連邦通信委員会認証' },
              { name: 'RoHS', desc: '有害物質使用制限指令' },
              { name: 'REACH', desc: '欧州化学物質規制' },
              { name: 'KC認証', desc: '韓国電子製品安全認証' }
            ]
          },
          medical: {
            title: '医療機器認証',
            description: '医療機器の安全性と効能を保証する認証',
            standards: [
              { name: 'ISO 13485', desc: '医療機器品質経営システム' },
              { name: 'CEマーク (MDR)', desc: '欧州医療機器規定' },
              { name: 'FDA 510(k)', desc: '米国医療機器上市前申告' },
              { name: 'MFDS認証', desc: '韓国食品医薬品安全処認証' },
              { name: 'CFDA', desc: '中国医療機器登録' }
            ]
          },
          environmental: {
            title: '環境認証',
            description: '環境に優しい製品を認証する国際標準',
            standards: [
              { name: 'ISO 14001', desc: '環境経営システム認証' },
              { name: 'Carbon Footprint', desc: 'カーボンフットプリント認証' },
              { name: 'FSC', desc: '森林管理協議会認証' },
              { name: 'Energy Star', desc: 'エネルギー効率認証' },
              { name: '環境ラベル', desc: '韓国環境ラベル認証' }
            ]
          }
        },
        standardsTitle: '主要認証標準'
      },

      certification: {
        companyName: '青島検査技術サービス有限会社',
        backToHome: 'ホームに戻る',
        badge: '主要事業',
        title: '認証業務/認証マーク',
        subtitle: 'グローバル市場進出のための各国の必須認証および認証マーク取得をサポートします。CCC、CE、FCC、ULなど多様な国際認証サービスを提供します。',
        servicesTitle: '主要認証サービス',
        servicesSubtitle: '各国の規制要件に適合した認証サービスを提供します',
        processingPeriod: '処理期間',
        validityPeriod: '有効期間',
        viewDetails: '詳細を見る',
        applicableProducts: '適用製品',
        certificationProcess: '認証手順',
        benefitsTitle: '認証の利点',
        benefitsSubtitle: '国際認証を通じて得られる様々なメリット',
        benefits: [
          {
            title: '市場参入の容易さ',
            description: '各国の規制要件を満たすことでグローバル市場への進出が可能です',
            icon: 'ri-global-line'
          },
          {
            title: '信頼性の向上',
            description: '国際認証を通じて製品の品質と安全性を証明できます',
            icon: 'ri-shield-check-line'
          },
          {
            title: '競争力の強化',
            description: '認証された製品は市場でより高い競争力を得ます',
            icon: 'ri-trophy-line'
          },
          {
            title: '法規遵守',
            description: '各国の法規を遵守し、法的リスクを最小化します',
            icon: 'ri-file-shield-line'
          }
        ],
        processTitle: '認証進行プロセス',
        processSubtitle: '体系的な認証手順により、迅速かつ正確な認証取得をサポートします',
        processSteps: [
          {
            step: '01',
            title: '相談及び見積',
            description: '製品及び認証要件の確認',
            icon: 'ri-customer-service-line'
          },
          {
            step: '02',
            title: '契約及び申請',
            description: '認証契約締結及び申請書提出',
            icon: 'ri-file-text-line'
          },
          {
            step: '03',
            title: '試験進行',
            description: '製品サンプル試験及び評価',
            icon: 'ri-flask-line'
          },
          {
            step: '04',
            title: '工場審査',
            description: '生産工場現場審査（必要時）',
            icon: 'ri-building-line'
          },
          {
            step: '05',
            title: '証明書発行',
            description: '証明書及びマーク使用承認',
            icon: 'ri-award-line'
          }
        ],
        certifications: [
          {
            id: 'ccc',
            name: 'CCC認証',
            fullName: 'China Compulsory Certification',
            country: '中国',
            description: 'System認証',
            products: ['電気電子製品', '自動車部品', '安全ガラス', '消防製品', '無線通信機器', '情報技術機器'],
            process: ['申請書提出および契約', '製品サンプル試験', '工場審査', '認証書発行', '事後管理'],
            period: '60-90日',
            validity: '5年'
          },
          {
            id: 'ce',
            name: 'CEマーク',
            fullName: 'Conformité Européenne',
            country: '欧州連合',
            description: 'SAH安全衛生マーク',
            products: ['電気電子製品', '機械類', '医療機器', '玩具', '個人保護設備', '建設資材'],
            process: ['適用指令確認', '適合性評価', '技術文書作成', 'CEマーク貼付', '適合性宣言書作成'],
            period: '30-60日',
            validity: '製品変更時まで'
          },
          {
            id: 'fcc',
            name: 'FCC認証',
            fullName: 'Federal Communications Commission',
            country: '米国',
            description: '品質保証マーク',
            products: ['無線通信機器', 'コンピュータおよび周辺機器', '家電製品', 'LED照明', '産業用電子機器'],
            process: ['製品分類確認', 'EMC試験', '認証書申請', 'FCC ID発行', 'ラベル貼付'],
            period: '20-40日',
            validity: '永久'
          },
          {
            id: 'system',
            name: 'System認証',
            fullName: 'Management System Certification',
            country: '国際',
            description: 'HSPM、自動車、社会的責任SA8000、ISO 9000/ISO 14000',
            products: ['HSPM（危害要素重点管理）', '自動車産業', 'SA8000（社会的責任）', 'ISO 9000（品質経営）', 'ISO 14000（環境経営）', '統合経営システム'],
            process: ['経営システム構築', '文書化作業', '内部審査', '認証審査', '認証書発行'],
            period: '90-120日',
            validity: '3年（年間事後審査）'
          },
          {
            id: 'sah',
            name: 'SAH安全衛生マーク',
            fullName: 'Safety And Hygiene Mark',
            country: '国際',
            description: 'ジュエリー/貴金属/宝石類、日用品、Silver用品、衛生用品、個人安全保護器具',
            products: ['ジュエリー/貴金属/宝石類', '日用品', 'Silver用品', '衛生用品', '個人安全保護器具', '生活用品'],
            process: ['製品安全性評価', '衛生試験', '有害物質検査', '品質検証', '認証書発行'],
            period: '30-60日',
            validity: '2年'
          },
          {
            id: 'quality',
            name: '品質保証マーク',
            fullName: 'Quality Assurance Mark',
            country: '国際',
            description: '貴金属/宝石類品質保証',
            products: ['貴金属製品', '宝石類', 'ダイヤモンド', '金/銀製品', '真珠', '高級ジュエリー'],
            process: ['成分分析', '品質検査', '純度測定', '鑑定書発行', '品質保証書発行'],
            period: '15-30日',
            validity: '永久'
          },
          {
            id: 'ul',
            name: 'UL認証',
            fullName: 'Underwriters Laboratories',
            country: '米国',
            description: '米国の製品安全認証機関で、世界的に認められる安全マークです。',
            products: ['電気電子製品', '火災安全製品', '産業用設備', '医療機器', '建設資材', '家電製品'],
            process: ['製品評価申請', 'サンプル試験', '工場審査', 'ULマーク承認', '定期工場審査'],
            period: '60-90日',
            validity: '年間更新'
          },
          {
            id: 'rohs',
            name: 'RoHS認証',
            fullName: 'Restriction of Hazardous Substances',
            country: '欧州連合',
            description: '電気電子製品の有害物質使用制限指令です。',
            products: ['電気電子製品', '家電製品', '照明機器', '玩具', '医療機器', '監視機器'],
            process: ['製品分析', '有害物質試験', '適合性評価', '認証書発行', '技術文書作成'],
            period: '15-30日',
            validity: '製品変更時まで'
          },
          {
            id: 'reach',
            name: 'REACH認証',
            fullName: 'Registration, Evaluation, Authorization of Chemicals',
            country: '欧州連合',
            description: 'EUの化学物質登録、評価、許可および制限に関する規定です。',
            products: ['化学物質', '繊維製品', '電気電子製品', '玩具', '家具', '包装材'],
            process: ['SVHC確認', '化学物質分析', '適合性評価', '報告書作成', '認証書発行'],
            period: '20-40日',
            validity: '1年'
          },
          {
            id: 'cpsia',
            name: 'CPSIA認証',
            fullName: 'Consumer Product Safety Improvement Act',
            country: '米国',
            description: '米国消費者製品安全改善法で、子供製品の安全基準です。',
            products: ['子供玩具', '乳幼児用品', '子供衣類', '学用品', '子供家具', '子供アクセサリー'],
            process: ['製品試験', '鉛含有量検査', 'フタル酸エステル検査', 'CPC認証書作成', 'ラベル貼付'],
            period: '15-30日',
            validity: '製品変更時まで'
          },
          {
            id: 'astm',
            name: 'ASTM F963',
            fullName: 'American Society for Testing and Materials',
            country: '米国',
            description: '米国玩具安全規格で、玩具の物理的、化学的安全性を評価します。',
            products: ['玩具', 'ゲーム', 'パズル', '人形', 'スポーツ玩具', '教育玩具'],
            process: ['物理的試験', '化学的試験', '可燃性試験', '適合性評価', '認証書発行'],
            period: '20-40日',
            validity: '製品変更時まで'
          }
        ],
        ctaTitle: '認証相談が必要ですか？',
        ctaDesc: '専門相談員が製品に最適な認証方法をご案内いたします。',
        ctaButton1: 'オンライン相談',
        ctaButton2: '電話お問い合わせ',
        ctaPhone: '電話相談',
        ctaPhoneNumber: '0532-55566163/55566165'
      }
    };

    export const common = {
      home: {
        hero: {
          slide1: {
            title: 'ISO/IEC 17025 認証第三者公認試験機関',
            subtitle: '正確な分析データに基づき\n信頼性の高い試験成績書と証明書を提供します。',
            cta: '詳細を見る'
          },
          slide2: {
            title: '最高水準の技術標準と専門エンジニア',
            subtitle: '安全/衛生環境を考慮した厳格な製品認証規格\n長年の経験を通じて蓄積された専門評価サービス\n顧客と市場が信頼する試験認証専門機関',
            cta: 'サービスを見る'
          },
          slide3: {
            title: 'グローバル認証ネットワーク',
            subtitle: 'CNAS、ILAC MRAなど国際公認認証保有\n世界市場進出のためのワンストップソリューション',
            cta: '認証を確認'
          }
        }
      }
    };
